import useStore from '@/store'
import styles from './Navigation.module.scss'
import classNames from 'classnames'
import Link from '@/components/Link/Link'
import LogoWordmarkAlt from '@/components/_svg/LogoWordmarkAlt'
import { HOME_SLUG } from '@/data'
import NavigationBar from '@/components/Navigation/NavigationBar/NavigationBar'
import Clock from '@/components/Clock/Clock'
import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import useBreakpoint from '@/hooks/use-breakpoint'

export const HEADER_ID = 'h3aduRrr'

const Navigation = () => {
  const globalData = useStore(state => state.globalData)
  const productGalleryImagesOpen = useStore(state => state.productGalleryImagesOpen)
  const $container = useRef()
  const loaderAnimationComplete = useStore(state => state.loaderAnimationComplete)
  const { isMobile } = useBreakpoint()

  useEffect(() => {
    if (!$container.current) return
    gsap.killTweensOf($container.current, 'opacity,autoAlpha')
    gsap.to($container.current, {
      autoAlpha: productGalleryImagesOpen ? 0 : 1,
      pointerEvents: productGalleryImagesOpen ? 'none' : 'auto',
    })
  }, [productGalleryImagesOpen])

  useEffect(() => {
    if (!loaderAnimationComplete) return
    if (!$container.current) return
    gsap.to($container.current, {
      autoAlpha: 1,
      duration: 0.8,
      delay: 0.8,
      pointerEvents: 'all',
    })
  }, [loaderAnimationComplete])

  if (!globalData) return

  return (
    <header
      id={HEADER_ID}
      ref={$container}
      className={classNames(styles.Navigation)}
    >
      {!isMobile && (
        <Link
          ariaLabel="Go home"
          link={{
            linkType: 'internal',
            link: {
              _type: 'page',
              slug: HOME_SLUG,
            },
          }}
          className={styles.logoLink}
        >
          <LogoWordmarkAlt className={styles.logoContainer__logo} />
        </Link>
      )}
      <NavigationBar className={styles.navigationBar} />
      {!isMobile && <Clock className={styles.clock} />}
    </header>
  )
}

Navigation.displayName = 'Navigation'

export default Navigation
